import {post, get, remove} from '@/lib/axios';

const favorite = {
  async get_favorite(page_count, page_num, name, type, sort) {
    return get(`/favorite`, {page_count, page_num, name, type, sort});
  },
  async add_favorite(data) {
    return post(`/favorite`, data);
  },
  async delete_favorite(id) {
    return remove(`/favorite/${id}`);
  },
};

export {favorite as default};
